import React, { Component } from "react";
import "./mobileMainHeader.scss";
import MobileSubHeader from "./mobileSubHeader.js";
import { Link, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import jwt from "../../utils/jwt";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../config";
import { Modal } from "antd";
import { Fetch } from "../../utils/fetch";
import { shouldShowConsentPopup, markConsentGiven } from "../../utils/consentUtils";
const options = [
  { value: "BUSOWNER", label: "MG" },
  { value: "ELECTRIC", label: "ELECTRIC" },
  { value: "OPERATOR", label: "GDS" },
];

class MobileMainHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMainHeaderHidden: false,
      lastScrollY: 0,
      showBusinessModel: false,
      showConsentModal: false,
      consentLoading: false,
    };
  }

  handleScroll = () => {
    const { lastScrollY } = this.state;

    const currentScrollY = window.scrollY;

    if (this.props.hasSubHeader) {
      if (currentScrollY > lastScrollY && currentScrollY > 0) {
        this.setState({ isMainHeaderHidden: true });
      } else {
        this.setState({ isMainHeaderHidden: false });
      }
    }

    this.setState({ lastScrollY: currentScrollY });
  };

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    let userType = decodedToken.userType || "OPERATOR";
    const mobile_number = decodedToken.mobileNo || "";
    if (sessionStorage.getItem("userType")) {
      userType = sessionStorage.getItem("userType");
    } else if (decodedToken.isElectricUser) {
      userType = "ELECTRIC";
    }

    const display = options.find((opt) => opt.value === userType)?.label;

    this.setState({ displayUserType: display, userType, mobile_number });

    if (shouldShowConsentPopup()) this.setState({ showConsentModal: true });
  }

  handleConsentAgree = async () => {
    this.setState({ consentLoading: true });
    try {
      await Fetch(`/user/updateConsent`, { method: "post" });
      markConsentGiven();
      this.setState({ showConsentModal: false });
    } catch (err) {
      console.log(err);
    }
    this.setState({ consentLoading: false });
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleBusinessModelClick = () => {
    this.setState((prevState) => ({
      showBusinessModel: !prevState.showBusinessModel,
    }));
  };

  onBusinessChange = (event) => {
    this.setState({
      oldBusinessType: this.state.userType,
      userType: event.target.value,
    });
  };

  confirmBusiness = () => {
    const { userType, oldBusinessType, mobile_number } = this.state;
    sessionStorage.setItem("userType", userType);
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Business Model Selected", {
      view_from: "login page",
      mobile_number: mobile_number,
      business_model_type: userType,
      type: oldBusinessType,
    });
    if (window.location.pathname === "/") {
      window.location.reload();
    } else {
      window.location.href = "/";
    }
  };

  render() {
    const { isMainHeaderHidden, displayUserType, userType, showBusinessModel, showConsentModal, consentLoading } =
      this.state;
    const { hasSubHeader, toggleSideMenu, location, toggleBottomDrawer } =
      this.props;

    // extract route name from url
    const routeName = location.pathname.replace("/", "");

    return (
      <>
        {showConsentModal && (
          <div style={{
            position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
            background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center",
            justifyContent: "center", zIndex: 9999, fontFamily: "Poppins, sans-serif",
          }}>
            <div style={{
              background: "#fff", borderRadius: "12px", padding: "28px 24px 24px",
              width: "320px", maxWidth: "90%", boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
              display: "flex", flexDirection: "column", alignItems: "center", gap: "12px",
            }}>
              <div style={{ fontSize: "36px" }}>⚠️</div>
              <div style={{ fontWeight: 700, fontSize: "16px", textAlign: "center" }}>
                Confirm your KYC consent
              </div>
              <div style={{ fontSize: "13px", color: "#555", textAlign: "center", lineHeight: 1.6 }}>
                zingbus stores your PAN/Aadhaar (encrypted) to verify your eligibility to operate. Please re-confirm your consent to keep your account active.
              </div>
              <button
                onClick={this.handleConsentAgree}
                disabled={consentLoading}
                style={{
                  marginTop: "8px", width: "100%", padding: "10px 0",
                  background: consentLoading ? "#a78bfa" : "#7c3aed",
                  color: "#fff", border: "none", borderRadius: "8px",
                  fontSize: "14px", fontWeight: 600,
                  cursor: consentLoading ? "not-allowed" : "pointer",
                }}
              >
                {consentLoading ? "Please wait..." : "I Agree"}
              </button>
            </div>
          </div>
        )}
        <div
          className={
            isMainHeaderHidden ? "mobileMainHeader hidden" : "mobileMainHeader"
          }
        >
          <div className="menuIcon" onClick={toggleSideMenu}>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/menuHamburgerIcon.svg"
              alt="Menu Icon"
            />
          </div>
          <div className="logo">
            <Link to="/">
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/header/operatorLogo.svg  "
                alt="Zingbus Logo"
              />
            </Link>
          </div>
          {userType != "CABOWNER" ? (
            <div
              className="businessModal"
              onClick={this.handleBusinessModelClick}
            >
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/header/userSelect.svg"
                alt="user"
              />
              <span>{displayUserType}</span>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/header/dropDown/downArrow.svg"
                alt="dropDown"
              />
            </div>
          ) : null}
        </div>
        {hasSubHeader && (
          <MobileSubHeader
            routeName={routeName}
            isMainHeaderHidden={isMainHeaderHidden}
            toggleBottomDrawer={toggleBottomDrawer}
          />
        )}

        {showBusinessModel ? (
          <Modal
            title="Select Business Model"
            centered
            open={showBusinessModel}
            onCancel={this.handleBusinessModelClick}
            cancelButtonProps={{ style: { display: "none" } }}
            okButtonProps={{ style: { display: "none" } }}
          >
            <div>
              {options.map((option, index) => (
                <label
                  key={index}
                  style={{ display: "flex", marginBottom: "12px", gap: "8px" }}
                >
                  <input
                    className="purple-Bg"
                    type="radio"
                    value={option.value}
                    checked={userType === option.value}
                    onChange={this.onBusinessChange}
                  />
                  {option.label}
                </label>
              ))}
            </div>

            <div className="modalFooter">
              <button className="primary" onClick={this.confirmBusiness}>
                Confirm
              </button>
              <div className="cancel" onClick={this.handleBusinessModelClick}>
                <span>cancel</span>
              </div>
            </div>
          </Modal>
        ) : null}

        <div className="pageContent">{this.props.children}</div>
      </>
    );
  }
}

export default withRouter(MobileMainHeader);
